module.exports = __webpack_public_path__ + "media/images/tip-man-8f42553b744fc6c22f2dfe9f610e9b93.svg";